import React, {useState} from "react";
import Ajax from "../inc/js/Ajax";
import {
    Avatar,
    Button,
    Link,
    Navbar, 
    NavbarBrand, 
    NavbarContent, 
    NavbarItem, 
    NavbarMenuToggle,
    NavbarMenu,
    NavbarMenuItem,
    mapPropsVariants,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownTrigger
  } from "@nextui-org/react";
  import swal from "sweetalert2";
  import {
    Menu_6_Black,
    Menu_8_Black,
    LogIn_8_Blue,
    X_8_Black
  } from "../inc/images/svgs";

  export default function Header({clientInformation}) {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const menuItems = [
        "Home",
        "Pricing",
        "FAQ",
        "Contact Us",
        "Privacy Policy"
    ];

    return(
        <Navbar
            shouldHideOnScroll
            isBordered
            maxWidth="2xl"
            classNames={{
                base: "border-b shadow-[0_8px_12px_rgba(59,130,246,0.20)]"
            }}
        >
            <NavbarContent justify="start">
                <NavbarBrand>
                    <Link href="/" color="foreground">
                        <h1 className="text-3xl sm:text-4xl font-black">JudgeAutos</h1>
                    </Link>
                </NavbarBrand>
            </NavbarContent>
            <NavbarContent className="sm:gap-10" justify="end">
                <NavbarItem>
                    <Link className="text-xl hidden sm:flex" color="foreground" href="/">
                        Home
                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link className="text-xl hidden sm:flex" color="foreground" href="/Pricing">
                        Pricing
                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link className="text-xl hidden sm:flex" color="foreground" href="/FAQ">
                        FAQ
                    </Link>
                </NavbarItem>
                <NavbarItem className="sm:hidden" justify="start">
                    <NavbarMenuToggle
                        icon={(isOpen) => (isOpen ? <X_8_Black /> : <Menu_8_Black />)}
                        aria-label={isMenuOpen ? "Close menu" : "Open menu"}
                    />
                </NavbarItem>
                {!clientInformation.userInformation.loggedIn ?(
                    <Link href="/Login">
                        <Avatar 
                            showFallback
                            size="sm"
                            radius="full"
                            classNames={{ name: "text-xl" }}
                            style={{ cursor: 'pointer' }}
                        />
                    </Link>
                ) : (
                    <NavbarItem>
                        <Link href="/MyAccount">
                            {clientInformation.userInformation.avatar ? (
                                <Avatar
                                    src={clientInformation.userInformation.avatar}
                                    style={{ cursor: 'pointer' }}
                                />
                            ) : (
                                <Avatar 
                                    showFallback
                                    size="sm"
                                    radius="full"
                                    color="primary"
                                    classNames={{ name: "text-xl" }}
                                    style={{ cursor: 'pointer' }}
                                />
                            )}
                        </Link>
                    </NavbarItem>
                )}
            </NavbarContent>
            <NavbarMenu>
                {menuItems.map((item, index) => (
                    <NavbarMenuItem key={`${item}-${index}`}>
                        <Link
                            href={item.toLowerCase() === "home" ? "/" : `/${item.replace(/\s+/g, '')}` }
                            color="foreground"
                            className="text-xl pt-6"
                        >
                            {item}
                        </Link>
                    </NavbarMenuItem>
                ))}
            </NavbarMenu>
        </Navbar>
    );
}